import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import LinkComponent from './LinkComponent'
// import '../public/images/bangkok.png'

const LargeSwiperImage = ({ title, imageSrc, type, location }) => {
    return (
        <LinkComponent href={`/properties?${type}=${location?.replaceAll(' ', '%20')}`} className='relative district-swiper-large-image w-[150px] h-[300px]'>
            <div className='w-[140px] h-[290px] relative overflow-hidden rounded-md shadow-md'>
                <Image
                    src={`/images/${location.toLowerCase().replaceAll('%20', '').replaceAll(' ', '')}.avif`}
                    fill={true}
                    className='object-cover'
                    alt={title}
                // style={{ objectFit: "contain" }}
                />
                <div className='absolute bottom-0 left-0 right-0 rounded-b-md flex justify-center h-[50px] items-start bg-maincolor/60 overflow-hidden'>
                    <span className='text-light z-10 px-1 rounded-sm text-center font-semibold'>{title}</span>
                </div>
            </div>
        </LinkComponent>
    )
}

export default LargeSwiperImage